<div class="admin-users-wrapper">

  <!-- Filter Bar: Users List -->
  @if (!allUsersMode) {
<div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         (click)="refresh()"
         title="Refresh Data"></i>
    </div>

    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="addUser()">Add New User(s)</div>
    </div>

    <div class="gt-filter-item">
      <select class="gt-filter-select"
              [(ngModel)]="selectedClientKey"
              (ngModelChange)="onClientChange()">
        @for (client of clients; track $index) {
<option
                [value]="client.client_key">{{ client.client_name }}</option>
}
      </select>
    </div>
  </div>
}

  <!-- Filter Bar: All Users List -->
  @if (allUsersMode) {
<div class="gt-filter-container">
    <div class="gt-filter-item">
      <i class="fa fa-refresh gt-refresh"
         [class.spinning]="loading"
         (click)="refresh()"
         title="Refresh Data"></i>
    </div>

    <div class="gt-filter-item">
      <div class="gt-multiselect-wrapper">
        <div class="gt-multiselect-btn" (click)="toggleUserMenu($event)">
          <span>{{ selectedUserCount }} Checked</span>
          <i class="fa fa-caret-down"></i>
          @if (selectedUserCount > 0) {
<span class="badge">{{ selectedUserCount }}</span>
}
        </div>
        @if (userMenuOpen) {
<div class="gt-multiselect-dropdown" [ngStyle]="userMenuStyle" (click)="$event.stopPropagation()">
          <div class="gt-multi-actions">
            <span (click)="selectAllUsers()"><i class="fa fa-check"></i> Check All</span>
            <span (click)="unselectAllUsers()"><i class="fa fa-times"></i> UnCheck All</span>
          </div>
          <input type="text" class="gt-multi-search" placeholder="Search..."
                 [(ngModel)]="userSearchText" (ngModelChange)="onUserSearch()">
          <ul class="gt-multi-list">
            @for (user of filteredUserOptions; track $index) {
<li
                (click)="toggleUserItem(user, $event)">
              <i class="fa" [ngClass]="user.checked ? 'fa-check-square-o' : 'fa-square-o'"></i>
              <span>{{ user.LABEL }}</span>
            </li>
}
          </ul>
          @if (loadingUsers) {
<div class="gt-multi-loading">
            <i class="fa fa-spinner fa-spin"></i> Loading users...
          </div>
}
        </div>
}
      </div>
    </div>

    <div class="gt-filter-item">
      <div class="btn btn-success btn-xs" (click)="filterGrid()">Filter</div>
    </div>
  </div>
}

  <!-- Gizmo Grid Container -->
  <div adminGrid
       [gridConfig]="gridConfig"
       (gridCallback)="onGridCallback($event)"
       (gridDataLoaded)="onGridDataLoaded($event)"
       (loadingStateChange)="loading = $event"
       class="gizmo-grid"
       tabindex="2"></div>

</div>
